import { IPlayer } from '../../user/store';

export interface IGroupCourse {
  id: number;
  name: string;
  address: string;
}

export interface IGroupEnrollment {
  event: number;
  flight: any;
  handicap: string | null;
  id: number;
  index: number;
  status?: string;
  team: number;
  tee: string;
  user: IPlayer;
}

export interface IGroupGameGame {
  enrollment: IGroupEnrollment;
  handicap: number;
  id: number;
  seat: number;
  tee: {
    distance: number;
    gender: string;
    id: number;
    name: string;
    par: number;
    rating: string;
    slope: number;
  };
}
export interface IGroupGame {
  games: IGroupGameGame[];
  enrollments: IGroupEnrollment[];
  id: number;
  round: number;
  scorer?: number;
  start: string;
  startingHole?: number;
  startingPosition?: string;
}

export interface ITeeGame {
  flight: number;
  id: number;
  round: number;
  tee: {
    id: number;
    name: string;
    par: number;
    rating: string;
    slope: number;
  };
}

export interface IRoundGame {
  course: IGroupCourse;
  event: number;
  holes: number;
  id: number;
  order: number;
  playersPerTee: number;
  shotgunStart: boolean;
  start: string;
  status: string;
  teeAssignments: ITeeGame[];
  teeFrequency: string;
}

export interface IHole {
  handicap: number;
  id: number;
  order: number;
  par: number;
  yards: number;
}

export interface IGame {
  enrollment: number;
  grossScore?: number;
  group: IGroupGame;
  id: number;
  qualified: boolean;
  handicap?: number;
  penalties?: number;
  round: IRoundGame;
  seat: number;
  signature?: boolean;
  status: string;
  currentTee?: {
    id: number;
    name: string;
    par: number;
    rating: string;
    slope: number;
    holes: IHole[];
  };
}

export interface IGamesStore {
  [id: number]: IGame;
}

export const gamesStore: IGamesStore = {};
